<template>
  <div class="ent-select-wrapper" :class="{ 'env-zh': isZH }" id="ent-select-wrapper" ref="entSelectRef">
    <div class="ent-select-contents" v-if="!isZH">
      <a class="m-ent-ttip" @click="handleExpand">
        <!-- <span class="dot-ent-namexxx" v-if="curEntInfo && curEntInfo.name">{{ curEntInfo && curEntInfo.name.length > 12 ?
          curEntInfo.name.substr(0, 12) + '...' : curEntInfo.name }}</span> -->
        <span class="dot-ent-namexxx" v-if="curEntInfo && curEntInfo.name"></span>
        <a-icon type="caret-up" v-show="expanded && entList.length > 1" />
        <a-icon type="caret-down" v-show="!expanded && entList.length > 1" />
      </a>
    </div>
    <div class="ent-select-contents" v-else>
      <a class="m-ent-ttip" @click="handleExpand">
        <span class="dot-ent-namexxx">杭州纵横智慧园区</span>
        <a-icon type="caret-up" v-show="expanded && entList.length > 1" />
        <a-icon type="caret-down" v-show="!expanded && entList.length > 1" />
      </a>
    </div>
    <div class="ent-drop-wrapper" v-show="expanded" ref="entDropRef">
      <div class="ent-search-header">
        <a-input-search placeholder="请搜索" class="ent-search" v-model="searchName" @search="fetchEnt" />
      </div>
      <ul class="ent-list">
        <li class="ent-m-item" :class="{ 'ent-m-item-active': currentSelectId == ent.id }" v-for="ent in entList"
          :key="ent.id" @click="handleChoiceEnt($event, ent)">{{ ent.name }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { queryEntList } from '@/api/projectTree.js'
import { setStore, getStore } from '@/utils/storage'
import { removeStore } from '../../utils/storage'
export default {
  props: {
    showVisible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      searchName: '',
      entList: [],
      isSelect: false,
      isInit: true,
      currentSelectId: '',
      expanded: false,
      curEntInfo: null,
      entDropRef: null,
      isZH: false
    }
  },
  watch: {
    showVisible (newV, oldV) {
      if (newV) {
        this.isSelect = true
        this.fetchList()
      }
    },
    curEntInfo (newV) {
      this.$nextTick(() => {
        this.$store.commit('ENT_CUR_WIDTH', this.$refs.entSelectRef.offsetWidth)
      })
    }
  },
  mounted () {
    const env = process.env.VUE_APP_ENV || process.env.VUE_APP_FORMATS
    if (env == 'zh') {
      this.isZH = true
    }
    this.isSelect = true
    this.isInit = true
    this.$nextTick(() => {
      this.initDomEvent()
    })
    this.fetchList()
  },
  methods: {
    initDomEvent () {
      document.addEventListener('click', (e) => {
        if (this.$refs.entDropRef) {
          const isSelf = this.$refs.entDropRef.contains(e.target)
          if (!isSelf) {
            this.expanded = false
          }
        }
      })
    },
    handleExpand (event) {
      event.stopPropagation()
      if (this.entList.length > 1) {
        this.expanded = !this.expanded
      }
    },
    onChange () {
      this.isSelect = false
      this.isInit = false
      this.fetchList()
    },
    handleCancel () {
      this.$emit("closeEntSelect", false)
      this.searchName = ''
    },
    handleChoiceEnt (event, item) {
      event.stopPropagation()
      this.isSelect = true
      this.expanded = false
      this.curEntInfo = item
      console.log(this.curEntInfo, 'this.curEntInfo111')

      this.$emit('changeEntInfo', item)
      setStore('curEnterpriseInfo', JSON.stringify(item))
      this.$store.commit("SET_ENTINFO", JSON.parse(getStore("curEnterpriseInfo")))
      this.$store.commit('CLICK_ENT', true)
      this.$emit("closeEntSelect", false)
      this.searchName = ''
      removeStore('projectInfo')
    },
    handleEntChange (cur) {
      const item = this.entList.filter((i) => i.id == cur)?.[0]
      this.isSelect = true
      this.$emit('changeEntInfo', item)
      setStore('curEnterpriseInfo', JSON.stringify(item))
      this.$store.commit("SET_ENTINFO", JSON.parse(getStore("curEnterpriseInfo")))
      this.$store.commit('CLICK_ENT', true)
      this.$emit("closeEntSelect", false)
      this.searchName = ''
      removeStore('projectInfo')
    },
    async fetchList (isSearch) {
      // removeStore('projectInfo')
      const data = {
        keywords: this.searchName
      }
      try {
        const { code, result, message } = await queryEntList(data)
        if (code === 1000) {
          this.entList = result || []
          if (this.entList.length && this.isSelect && !isSearch) {
            const savedEntInfo = JSON.parse(getStore("curEnterpriseInfo"))
            if (savedEntInfo) {
              this.currentSelectId = savedEntInfo.id
              this.curEntInfo = savedEntInfo
              this.$emit('changeEntInfo', savedEntInfo)
              setStore('curEnterpriseInfo', JSON.stringify(savedEntInfo))
              this.$store.commit("SET_ENTINFO", savedEntInfo)
              this.$store.dispatch('projectFetch', savedEntInfo)
            } else {
              // add by bb 20231017  判断是否有选定的企业，如果没有则默认为第一个企业
              let selectedEnterprise = false
              for (let index = 0; index < this.entList.length; index++) {
                const element = this.entList[index]
                if (element && element.selectedEnterprise) {
                  selectedEnterprise = true
                  this.currentSelectId = element.id
                  this.curEntInfo = element
                  this.$emit('changeEntInfo', element)
                  setStore('curEnterpriseInfo', JSON.stringify(element))
                  this.$store.commit("SET_ENTINFO", element)
                  this.$store.dispatch('projectFetch', element)
                  break
                }
              }
              if (!selectedEnterprise) {
                this.currentSelectId = this.entList[0].id
                this.curEntInfo = this.entList[0]
                this.$emit('changeEntInfo', this.entList[0])
                setStore('curEnterpriseInfo', JSON.stringify(this.entList[0]))
                this.$store.commit("SET_ENTINFO", this.entList[0])
                this.$store.dispatch('projectFetch', this.entList[0])
              }
            }

          }
          if (this.isInit) {
            this.$store.commit("SET_ENTS", this.entList)
          }
        } else {
          this.$message.warning(message)
        }
      } catch (error) {
        this.$message.error('服务器异常，请重试')
      }
    },
    fetchEnt () {
      this.fetchList(true)
    }
  }
}
</script>
<style>
.m-custom-ent-select {
  max-height: 300px;
  overflow-y: auto;
  width: 240px;
}

.mm-ent-select {
  width: 100%;
  margin-left: 16px !important;
  max-width: 140px;
}

.mm-ent-select>div {
  background: transparent;
  border: none;
}

.mm-ent-select>div>div>div {
  color: #fff;
  font-weight: 500;
  font-size: 20px;
}
</style>
<style lang="less" scoped>
.env-zh {
  .dot-ent-namexxx {
    color: #262626;
  }
}

.ent-list {
  list-style: none;

  li {
    padding: 5px 16px;
    height: 32px;
    line-height: 32px;
    color: #262626;
    font-size: 14px;
    margin-bottom: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}

.ent-search-header {
  width: 100%;
  padding: 12px 16px;
}

.m-ent-ttip {
  font-weight: 500;
  font-size: 20px;
  line-height: 56px;
  height: 56px;
  color: #ffffff;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
  text-decoration: none;
}

.ent-select-contents {
  width: 100%;
  height: 56px;
  line-height: 56px;
}

.ent-drop-wrapper {
  position: absolute;
  z-index: 999999 !important;
  left: 18px;
  top: 66px;
  width: 280px;
  background: #ffffff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.12), 0px 4px 16px rgba(0, 0, 0, 0.08),
    0px 6px 28px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  max-height: 368px;
  overflow-y: auto;
}

.ent-select-wrapper {
  position: fixed;
  // width: 200px;
  padding-left: 78px;
  z-index: 999;
  left: 0;
  top: 0;
  max-width: 350px;
}

.entprise-select-search {
  width: 294px;
  margin-bottom: 16px;
}

.entprise-select-dialog {
  .business-modal-content {
    width: 750px;
  }
}

.entprise-select-list {
  margin-left: 0;
  padding-left: 0;
}

.entprise-select-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 8px;

  .entprise-select-name {
    flex: 1;
    color: #262626;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .entprise-select-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    background: url('~@/assets/images/common/ent-select-icon.png') no-repeat center;
    background-size: 100%;
    margin-right: 8px;
  }
}
</style>
